/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a workshop.
 * @export
 * @interface WorkshopCreate
 */
export interface WorkshopCreate {
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    mentor_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    class_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopCreate
     */
    add_class_members?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopCreate
     */
    start_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopCreate
     */
    end_time: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopCreate
     */
    series_id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopCreate
     */
    problem_ids?: Array<string> | null;
}

/**
 * Check if a given object implements the WorkshopCreate interface.
 */
export function instanceOfWorkshopCreate(value: object): value is WorkshopCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mentor_id' in value) || value['mentor_id'] === undefined) return false;
    if (!('start_time' in value) || value['start_time'] === undefined) return false;
    if (!('end_time' in value) || value['end_time'] === undefined) return false;
    return true;
}

export function WorkshopCreateFromJSON(json: any): WorkshopCreate {
    return WorkshopCreateFromJSONTyped(json, false);
}

export function WorkshopCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'mentor_id': json['mentor_id'],
        'class_id': json['class_id'] == null ? undefined : json['class_id'],
        'add_class_members': json['add_class_members'] == null ? undefined : json['add_class_members'],
        'start_time': (new Date(json['start_time'])),
        'end_time': (new Date(json['end_time'])),
        'series_id': json['series_id'] == null ? undefined : json['series_id'],
        'problem_ids': json['problem_ids'] == null ? undefined : json['problem_ids'],
    };
}

export function WorkshopCreateToJSON(json: any): WorkshopCreate {
    return WorkshopCreateToJSONTyped(json, false);
}

export function WorkshopCreateToJSONTyped(value?: WorkshopCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'mentor_id': value['mentor_id'],
        'class_id': value['class_id'],
        'add_class_members': value['add_class_members'],
        'start_time': ((value['start_time']).toISOString()),
        'end_time': ((value['end_time']).toISOString()),
        'series_id': value['series_id'],
        'problem_ids': value['problem_ids'],
    };
}

